// @flow

import { bindActionCreators } from 'redux';
import type { Dispatch } from 'redux';
import { connect } from 'react-redux';
import * as Selectors from '../selectors';
import ManageLocations from '../components/pages/settings/manage/locations';
import {
  fetchTags,
  createTag,
  updateTag,
  deleteTag,
  assignTagToLocation,
  removeTagFromLocation,
  bulkAssignTags,
  bulkRemoveTags,
  hydrateLocationTags,
} from '../actions/tags';

function mapStateToProps(state) {
  return {
    recordings: Selectors.getRecordings(state),
    locations: Selectors.getLocations(state),
    entityTags: Selectors.getEntityTags(state),
  };
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  return bindActionCreators(
    {
      fetchTags,
      createTag,
      updateTag,
      deleteTag,
      assignTagToLocation,
      removeTagFromLocation,
      bulkAssignTags,
      bulkRemoveTags,
      hydrateLocationTags,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageLocations);
